<template>
  <transition name="send-modal">
    <div v-if="isModalOpened" class="modal-backdrop send-message-backdrop" @click="closeModal">
      <send-message
        :sending="sending"
        :send-message-outcome="sendMessageOutcome"
        :default-recipient="defaultRecipient"
        :patients-list="patientsList"
        @send-message="sendMessage"
        @close-modal="closeModal"
        @reset-suggestions="handleResetSuggestions"
        @fetch-patients="fetchPatientsList"
      />
    </div>
  </transition>
</template>

<script>
import SendMessage from '@ui-kit/components/dt-messages/SendMessage.vue'

const MESSAGE_STATUS = {
  SUCCESS: 'success',
  ERROR: 'error',
}

export default {
  name: 'SendMessageModal',
  components: {
    SendMessage,
  },
  data() {
    return {
      sending: false,
      sendMessageOutcome: '',
    }
  },
  computed: {
    isModalOpened() {
      return this.$store.getters['general/isModalOpened']('sendMessage')
    },
    isMemberRoute() {
      return !!this.$route.params?.patientID
    },
    defaultRecipient() {
      // checks if current route is member's profile route and gets the data of selected patient
      if (this.isMemberRoute) {
        const patient = this.$store.getters['patient/getPatient']

        if (!patient.user_id) {
          return null
        }

        return this.getFormattedPatientInfoForMessageForm(patient)
      }
      const todoListPatient = this.$store.getters['todoList/getSelectedPatient']

      if (todoListPatient) {
        return todoListPatient
      }

      const patientSummarySideBarInfo = this.$store.getters['patient/patientSummary/getPatientSummarySideBarInfo']

      if (patientSummarySideBarInfo) {
        return this.getFormattedPatientInfoForMessageForm(this.patientSummarySideBarInfo)
      }

      return null
    },
    patientsList() {
      const allPatients = this.$store.getters['patientsList/getAllPatientsList']

      if (!allPatients) {
        return []
      }

      return allPatients.map((patient) => ({
        ...patient,
        vip: patient.is_vip_account || false,
        name: `${patient.firstname} ${patient.lastname}`,
      }))
    },
  },
  methods: {
    async sendMessage(messageData) {
      try {
        this.sending = true
        this.sendMessageOutcome = ''
        const professionalRefID = this.$store.getters['user/getUserId']

        await this.$http('general/sendMessage', null, { body: { ...messageData, professionalRefID } })
        this.sendMessageOutcome = MESSAGE_STATUS.SUCCESS
        setTimeout(this.closeModal, 1000)
      } catch (e) {
        this.sendMessageOutcome = MESSAGE_STATUS.ERROR
        console.error(`It was not possible to send the message to member with id ${messageData}.`)
      } finally {
        this.sending = false
      }
    },
    closeModal() {
      this.$store.commit('general/toggleShowModal', { sendMessage: false })
      this.$store.commit('todoList/setSelectedPatient', null)
      this.sendMessageOutcome = ''
    },
    handleResetSuggestions() {
      this.$store.dispatch('patientsList/resetAllPatientsList')
    },
    async fetchPatientsList(recipientName) {
      try {
        this.$store.dispatch('patientsList/fetchAllPatients', { search: recipientName })
      } catch (e) {
        this.$notify.error('Failed to fetch patients')
      }
    },
    getFormattedPatientInfoForMessageForm(patient) {
      return {
        user_id: patient.user_id,
        firstname: patient.general.firstname,
        lastname: patient.general.lastname,
        name: `${patient.general.firstname} ${patient.general.lastname}`,
        gender: patient.general.gender,
        picture: patient.general.picture,
        institution_id: patient.institution_id,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-backdrop.send-message-backdrop {
  background-color: transparent;
}

.send-modal-enter,
.send-modal-leave-to {
  opacity: 0;
  transform: translateX(110%);
}

.send-modal-enter-to,
.send-modal-leave {
  opacity: 1;
  transform: translateX(0);
}

.send-modal-enter-active {
  transition: all 0.3s ease-out;
}

.send-modal-leave-active {
  transition: all 0.1s ease-in;
}
</style>
